<template>
  <div class="teas-my-schedule-div">
    <div class="teas-my-schedule-calendar-div">
      <my-schedule-calendar
        @loadDayDataArray="loadDayDataArray"
        :url="url"
        :isDesign="isDesign"
        ref="scheduleCalendar"
      ></my-schedule-calendar>
    </div>
    <div class="teas-my-schedule-content">
      <van-empty v-if="dataList.length == 0" description="暂无数据" />
      <div class="teas-my-schedule-list" v-else>
        <div
          v-for="(item, index) in dataList"
          :key="'teas-my-schedule-list-item' + index"
          class="teas-my-schedule-list-item"
        >
          <DsfMobileTeasCell
            cellShape="none"
            :border="true"
            :title="item.className || ''"
          >
            <DsfMobileTeasCellItem
              :value="item.courseName || '暂无'"
              icon="icon-icon-kc"
            >
            </DsfMobileTeasCellItem>
            <DsfMobileTeasCellItem
              :value="item.teachingMode || '暂无'"
              icon="icon-icon-kcfl"
            >
            </DsfMobileTeasCellItem>
            <DsfMobileTeasCellItem
              :value="item.courseTime || '暂无'"
              icon="icon-shijian2"
            >
            </DsfMobileTeasCellItem>
            <DsfMobileTeasCellItem
              :value="item.teacher || '暂无'"
              icon="icon-icon-teacher"
            >
            </DsfMobileTeasCellItem>
            <DsfMobileTeasCellItem
              :value="item.classroom || '暂无'"
              icon="icon-location-hollow"
            >
            </DsfMobileTeasCellItem>
          </DsfMobileTeasCell>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import myScheduleCalendar from "./components/myScheduleCalendar.vue";
export default dsf.component({
  name: "DsfMobileTeasMySchedule",
  ctrlCaption: "我的课表",
  mixins: [$mixins.control],
  components: {
    myScheduleCalendar,
  },
  design: {
    isMask: false,
  },
  data() {
    return {
      dataList: [],
    };
  },
  props: {
    url: {
      type: String,
      default: "teas/schedule/course/arrange/getUserCourseByTime",
    },
  },
  created() {
    if (this.isDesign) {
      this.$dispatch("design-width-change", "100%");
    } else {
      this.$nextTick(() => {
        this.$refs.scheduleCalendar.firstLoadData();
      });
    }
  },
  mounted() {},
  computed: {},
  methods: {
    loadDayDataArray(timeString) {
      if (this.isDesign) {
        return;
      }
      const loading = dsf.layer.loading();
      let urlString = this.url || "";
      let params = {};
      params = {
        stime: timeString + " " + "00:00:00",
        etime: timeString + " " + "23:59:59",
        isnum: false,
      };
      let _this = this;
      this.$http
        .get(urlString, params)
        .done((res) => {
          dsf.layer.closeLoading(loading);
          if (res.success) {
            let dataObject = res.data || {};
            let tempArray = [];
            Object.keys(dataObject).forEach((item) => {
              let tempItem = dataObject[item] || [];
              tempArray.push(...tempItem);
            });
            this.dataList = tempArray;
          } else {
            dsf.layer.message(res.message || "请求失败", false);
          }
        })
        .error((err) => {
          dsf.layer.closeLoading(loading);
          dsf.layer.message(err.message || "出错了，请重试", false);
        });
    },
  },
});
</script>
<style lang="scss">
</style>
